// mixins/currencyRouteMixin.js
export default {
  computed: {
    currentCurrency() {
      const validCurrencies = this.$store.getters.validCurrencies;
      const temporaryUser = this.$store.state.user.temporaryUser;
      const tempCurrency = temporaryUser?.currency;

      // Utiliser temporaryUser.currency seulement si c'est un code ISO valide
      if (tempCurrency && validCurrencies.includes(tempCurrency)) {
        return tempCurrency;
      }

      return this.$store.state.currency.currency;
    }
  },
  methods: {
    ensureCurrencyInQuery() {
      if (!this.currentCurrency) return;

      if (this.$route.query["currency[eq]"] !== this.currentCurrency) {
        const newQuery = {
          ...this.$route.query,
          "currency[eq]": this.currentCurrency,
          page: this.$route.query.page || "1",
          limit: this.$route.query.limit || "10"
        };

        this.$router.replace({ query: newQuery }).catch(err => {
          // Ignorer les erreurs de navigation dupliquée
          if (err.name !== 'NavigationDuplicated') {
            console.error('Currency route update error:', err);
          }
        });
      }
    }
  },
  mounted() {
    // Defer to after the host component's mounted() has run and set up its initial query
    // (page, limit, defaultFilters). This avoids a race where ensureCurrencyInQuery reads
    // an incomplete $route.query and overwrites params like paidAt:gte.
    this.$nextTick(() => {
      if (this.currentCurrency) this.ensureCurrencyInQuery();
    });
  },
  watch: {
    currentCurrency(newCurrency) {
      if (newCurrency) this.ensureCurrencyInQuery();
    }
  }
};
